import { UserFragmentFragment } from '@apps/www/src/__generated__/graphql';
import SVRedirect from '@apps/www/src/www/containers/SVRedirect';
import useAuthHasTeamPrivileges from '@apps/www/src/www/hooks/useAuthHasTeamPrivileges';
import useAuthTeam from '@apps/www/src/www/hooks/useAuthTeam';
import useAuthUser from '@apps/www/src/www/hooks/useAuthUser';
import useIsLoggedIn from '@apps/www/src/www/hooks/useIsLoggedIn';
import SVFeedCTAs from '@pkgs/shared-client/components/SVFeedCTAs';

const SVTeamHomeContainer = ({ children }: { children: React.ReactNode }) => {
	const isLoggedIn = useIsLoggedIn();
	const team = useAuthTeam();
	const user = useAuthUser([
		'_id',
		'name',
		'username',
		'url',
		'avatarURL',
	]) as UserFragmentFragment;
	const hasTeamPrivileges = useAuthHasTeamPrivileges();

	if (!hasTeamPrivileges || !isLoggedIn || !team || !user) {
		if (team) {
			return <SVRedirect to="/team/users/" />;
		} else {
			return <SVRedirect to="/team/create/" />;
		}
	}

	return (
		<div className="-md:flex-col relative flex w-full">
			<SVFeedCTAs />
			<div className="flex-1">{children}</div>
		</div>
	);
};

// @ts-ignore fix this
SVTeamHomeContainer.withUserSideMenu = true;

export default SVTeamHomeContainer;
